module.exports = __webpack_public_path__ + "static/media/0313_Small.1beb6180.jpg";